import { pushToDataLayer } from '../utils/pushToDataLayer';
import { GACustomEvent } from '../utils/types';

export function sorting(sortBy: string) {
    pushToDataLayer({
        event: GACustomEvent.Sorting,
        sort_by: sortBy.toLowerCase(),
    });
}
